<div class="row mt-4">
  @for (property of properties(); track property.id; let i = $index) {
    <div class="col-lg-4 col-md-6 col-sm-12 mb-4">
      <app-property-item [property]="property" [listId]="listId()"></app-property-item>
    </div>
  }
</div>
